import { render, staticRenderFns } from "./form.vue?vue&type=template&id=49fa2f9c&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49fa2f9c')) {
      api.createRecord('49fa2f9c', component.options)
    } else {
      api.reload('49fa2f9c', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=49fa2f9c&", function () {
      api.rerender('49fa2f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/department/form.vue"
export default component.exports